import * as React from 'react';
import styles from './index.less';
import { Dispatch } from 'redux';
import {
  OnAdd_Policy_Action,
  OnMount_PolicyPage_Action,
  ResourceAuthPageModelState,
  UpdatePoliciesAction,
} from '@/models/resourceAuthPage';
import {
  OnChange_Page_Action,
  OnMount_Page_Action as OnMount_Sidebar_Action,
} from '@/models/resourceSider';
import { useParams } from 'umi';
import { connect } from 'dva';
import { ConnectState } from '@/models/connect';
import FComponentsLib from '@freelog/components-lib';
import { FI18n } from '@freelog/tools-lib';
import FPolicyList from '@/components/FPolicyList';
import PolicyTemplates from '@/components/FPolicyTemplates';
import FIcons from '@/components/FIcons';

interface PolicyProps {
  dispatch: Dispatch;
  resourceAuthPage: ResourceAuthPageModelState;
}

function Policy({ dispatch, resourceAuthPage }: PolicyProps) {
  const params = useParams<{ id: string }>();
  // 同一子路由下仅 :id 变化时组件会复用，useMount 不会再次执行，需依赖 resourceID 重新拉取侧栏与策略数据
  React.useEffect(() => {
    const resourceID = params.id;
    if (!resourceID) {
      return;
    }
    dispatch<OnMount_Sidebar_Action>({
      type: 'resourceSider/onMount_Page',
      payload: {
        resourceID,
      },
    });
    dispatch<OnMount_PolicyPage_Action>({
      type: 'resourceAuthPage/onMount_PolicyPage',
      payload: {
        resourceID,
      },
    });
    dispatch<OnChange_Page_Action>({
      type: 'resourceSider/onChange_Page',
      payload: {
        page: 'policy',
      },
    });
  }, [dispatch, params.id]);

  return (
    <>
      <div className={styles.root}>
        <div style={{ height: 40 }} />
        <div className={styles.block}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <FComponentsLib.FContentText
              text={FI18n.i18nNext.tAuto('authplanmgnt_title')}
              type={'highlight'}
            />
            {resourceAuthPage.policies.length > 0 && (
              <FComponentsLib.FTextBtn
                style={{
                  fontSize: 12,
                  fontWeight: 600,
                  display: 'flex',
                  alignItems: 'center',
                  gap: 5,
                }}
                type='primary'
                onClick={async () => {
                  dispatch<OnAdd_Policy_Action>({
                    type: 'resourceAuthPage/onAdd_Policy',
                    payload: {
                      trigger: 'resource',
                    },
                  });
                }}
              >
                <FIcons.FPolicy style={{ fontSize: 14 }} />
                <span>添加策略</span>
              </FComponentsLib.FTextBtn>
            )}
          </div>
          {resourceAuthPage.policies.length === 0 && (
            <>
              <div style={{ height: 10 }} />
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                }}
              >
                <FComponentsLib.FContentText
                  text={'资源需添加授权策略才能上架到资源市场，开放签约。'}
                  type={'additional2'}
                />
                <FComponentsLib.FContentText
                  text={'授权策略，即资源对外授权范围和条件的申明，如支付10元获得一个月使用授权。'}
                  type={'additional2'}
                />
                <div style={{ height: 20 }} />

                <FComponentsLib.FRectBtn
                  type={'primary'}
                  onClick={() => {
                    dispatch<OnAdd_Policy_Action>({
                      type: 'resourceAuthPage/onAdd_Policy',
                      payload: {
                        trigger: 'resource',
                      },
                    });
                  }}
                >
                  {FI18n.i18nNext.tAuto('authplanmgnt_list_empty_btn')}
                </FComponentsLib.FRectBtn>
              </div>
            </>
          )}

          {resourceAuthPage.policies.length > 0 && (
            <>
              <div style={{ height: 20 }} />
              <FPolicyList
                atLeastOneUsing={resourceAuthPage.status === 1}
                dataSource={resourceAuthPage.policies}
                onCheckChange={(data) => {
                  if (data.using) {
                    self._czc?.push(['_trackEvent', '授权信息页', '上线', '', 1]);
                  }
                  dispatch<UpdatePoliciesAction>({
                    type: 'resourceAuthPage/updatePolicies',
                    payload: {
                      updatePolicies: [
                        {
                          policyId: data.id,
                          status: data.using ? 1 : 0,
                        },
                      ],
                    },
                  });
                }}
              />
            </>
          )}
        </div>

        <div style={{ height: 5 }} />

        <div className={styles.block}>
          <FComponentsLib.FContentText
            text={
              // 策略模板
              FI18n.i18nNext.tAuto('authplanmgnt_title_templates')
            }
            type={'highlight'}
          />
          <div style={{ height: 5 }} />
          <FComponentsLib.FContentText
            text={FI18n.i18nNext.tAuto('authplanmgnt_title_templates_help')}
            type={'additional2'}
          />
          <div style={{ height: 20 }} />
          {resourceAuthPage.resourceTypeCode && (
            <PolicyTemplates
              resourceTypeCode={resourceAuthPage.resourceTypeCode}
              onSelect={(value) => {
                dispatch<OnAdd_Policy_Action>({
                  type: 'resourceAuthPage/onAdd_Policy',
                  payload: {
                    defaultValue: value,
                    trigger: 'resource',
                  },
                });
              }}
            />
          )}
        </div>

        <div style={{ height: 100 }} />
      </div>
    </>
  );
}

export default connect(({ resourceAuthPage }: ConnectState) => ({
  resourceAuthPage: resourceAuthPage,
}))(Policy);
